import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow } from "vue"

const _hoisted_1 = {
  id: "modal_add_kyc_verification",
  ref: "AddKycVerificationModalRef",
  "aria-hidden": "true",
  class: "modal fade",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-600px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  id: "kt_modal_add_kyc_verification_header",
  class: "modal-header"
}
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "fw-bolder" }
const _hoisted_7 = {
  class: "btn btn-icon btn-sm btn-active-icon-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "modal-body py-10 px-lg-10" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-12 form-group mb-7" }
const _hoisted_12 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_13 = { class: "col-md-12 form-group mb-7" }
const _hoisted_14 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_15 = { class: "col-md-12 form-group mb-7" }
const _hoisted_16 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_17 = { class: "modal-footer justify-content-end gap-2" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "svg-icon svg-icon-3" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "svg-icon svg-icon-3" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_28 = { class: "modal-body py-10 px-lg-10" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-md-12 form-group mb-7" }
const _hoisted_31 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_32 = { class: "col-md-12 form-group mb-7" }
const _hoisted_33 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_34 = { class: "col-md-12 form-group mb-7" }
const _hoisted_35 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_36 = { class: "col-md-12 form-group mb-7" }
const _hoisted_37 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_38 = { class: "col-md-12 form-group mb-7" }
const _hoisted_39 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_40 = { class: "modal-footer justify-content-end gap-2" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { class: "svg-icon svg-icon-3" }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_46 = ["disabled"]
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { class: "svg-icon svg-icon-3" }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_MbInputCountry = _resolveComponent("MbInputCountry")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_MbInputTelephone = _resolveComponent("MbInputTelephone")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("kyc.add.title")), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        (_ctx.entityType === _ctx.KycType.Juridical)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 0,
              ref: "juridicalFormRef",
              model: _ctx.juridicalFormData,
              rules: _ctx.juridicalRules
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("kyc.add.companyName")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "company_name" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.juridicalFormData.company_name,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.juridicalFormData.company_name) = $event)),
                            type: "text",
                            placeholder: _ctx.$t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("kyc.add.countryCode")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "country_code" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_MbInputCountry, {
                            modelValue: _ctx.juridicalFormData,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.juridicalFormData) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("kyc.add.companyRegistrationNumber")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "company_registration_number" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.juridicalFormData.company_registration_number,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.juridicalFormData.company_registration_number) = $event)),
                            type: "text",
                            placeholder: _ctx.$t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])), [
                  [_directive_loading, _ctx.loading]
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-lg btn-light",
                    disabled: _ctx.loading,
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.modalHide && _ctx.modalHide(...args)))
                  }, [
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                          _createElementVNode("span", _hoisted_20, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("common.cancel")), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_21, [
                          _hoisted_22,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                        ]))
                  ], 8, _hoisted_18),
                  _createElementVNode("button", {
                    type: "button",
                    ref: "submitButton",
                    class: "btn btn-lg btn-primary",
                    disabled: _ctx.loading,
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submitJuridicalForm && _ctx.submitJuridicalForm(...args)))
                  }, [
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                          _createElementVNode("span", _hoisted_25, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("common.submit")), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_26, [
                          _hoisted_27,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                        ]))
                  ], 8, _hoisted_23)
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"]))
          : _createCommentVNode("", true),
        (_ctx.entityType === _ctx.KycType.Natural)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 1,
              ref: "naturalFormRef",
              model: _ctx.naturalFormData,
              rules: _ctx.naturalRules
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t("kyc.add.firstName")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "firstname" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.naturalFormData.firstname,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.naturalFormData.firstname) = $event)),
                            type: "text",
                            placeholder: _ctx.$t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t("kyc.add.lastName")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "lastname" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.naturalFormData.lastname,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.naturalFormData.lastname) = $event)),
                            type: "text",
                            placeholder: _ctx.$t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t("kyc.add.passportNo")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "passport" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.naturalFormData.passport,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.naturalFormData.passport) = $event)),
                            type: "text",
                            placeholder: _ctx.$t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t("kyc.add.passportCountry")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "country_code" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_MbInputCountry, {
                            modelValue: _ctx.naturalFormData,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.naturalFormData) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t("kyc.add.telephone")) + ":", 1),
                      _withDirectives(_createVNode(_component_el_form_item, { prop: "area_code" }, null, 512), [
                        [_vShow, 0]
                      ]),
                      _createVNode(_component_el_form_item, { prop: "telephone" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_MbInputTelephone, {
                            modelValue: _ctx.naturalFormData,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.naturalFormData) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])), [
                  [_directive_loading, _ctx.loading]
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-lg btn-light",
                    disabled: _ctx.loading,
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.modalHide && _ctx.modalHide(...args)))
                  }, [
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                          _createElementVNode("span", _hoisted_43, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("common.cancel")), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_44, [
                          _hoisted_45,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                        ]))
                  ], 8, _hoisted_41),
                  _createElementVNode("button", {
                    type: "button",
                    ref: "submitButton",
                    class: "btn btn-lg btn-primary",
                    disabled: _ctx.loading,
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.submitNaturalForm && _ctx.submitNaturalForm(...args)))
                  }, [
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                          _createElementVNode("span", _hoisted_48, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("common.submit")), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_49, [
                          _hoisted_50,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                        ]))
                  ], 8, _hoisted_46)
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 512))
}